import { Component, OnInit } from '@angular/core';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { UsersFacade } from '@app/shared/+state/users/users.facade';
import { of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { SmartDevicesService } from '../../service/smart-devices.service';

@Component({
  standalone: false,
  selector: 'device-settings',
  templateUrl: 'device-settings.component.html',
  styleUrls: ['device-settings.component.scss'],
})
export class DeviceSettingsComponent implements OnInit {
  connectedAccounts$;

  loadingConnectionUrl = false;

  hasWriteAccess$ = this.permissionsService.hasAccessTo(Features.PERM_SMARTLOCKS_DASHBOARD_WRITE);

  constructor(
    private smartService: SmartDevicesService,
    private permissionsService: UserPermissionsService,
    private usersFacade: UsersFacade
  ) {}

  ngOnInit() {
    this.hydrateConnectedAccounts();
  }

  hydrateConnectedAccounts() {
    this.connectedAccounts$ = this.smartService.getConnectedAccounts().pipe(
      map((res) => ({ data: res, loading: false, error: false })),
      startWith({ data: null, loading: true, error: false }),
      catchError((e) => of({ data: null, loading: false, error: 'Error fetching accounts' }))
    );
  }
}
